/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { css }     from 'styled-components';
import { lighten } from 'polished';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const FormOutline = (colour) => css`
  outline: 0;
  box-shadow: 0 0 0 3px ${lighten(0.2, colour)};
  border: 1px solid ${colour};
`;



// WEBPACK FOOTER //
// ./src/components/atoms/FormOutline/index.js